module.exports = __webpack_public_path__ + "static/media/clipping.5f1637be.svg";